import React, { useContext, useState } from 'react'
import { LoginWrapper, FormWrapper, PasswordContainer } from './style'
import { InputLogin } from 'src/components/Global/Input/Input'
import { VerificationButton } from 'src/components/Global/Button/Button'
import { eye } from 'src/assets'
import { useDispatch } from 'react-redux'
import { Link, useNavigate } from 'react-router-dom'
import { Spinner } from 'src/components/Global/Spinner/Spinner'
import { SnackbarContext } from 'src/contexts/Snack'
import useSnackbar from 'src/hooks/useSnackBar'
import { loginAction } from 'src/redux/actions/auth'
import { LoginDto } from 'src/services/types'
import { validateSignIn } from 'src/components/Validate/validate'
import { FiEye, FiEyeOff } from 'react-icons/fi'
const LoginForm = () => {
  const [passwordShown, setPasswordShown] = useState(false)
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const [userData, setUserData] = useState<LoginDto>({
    email: '',
    password: '',
  })
  const { email, password } = userData

  const [loading, setLoading] = useState<boolean>(false)

  const snackbarCtx: any = useContext(SnackbarContext)

  const { state: snackbarState } = snackbarCtx

  const handleChange = (e: any) => {
    const { name, value } = e.target
    const newData: any = { ...userData }
    newData[name] = value
    setUserData(newData)
  }

  const LoginAccount = (e: any) => {
    e.preventDefault()
    const error = validateSignIn(userData)
    if (error.error) {
      snackbar.trigger({
        message: error.error.message,
        severity: 'warning',
      })
      return
    }
    dispatch(loginAction({ userData, onSuccess, onError }))
    setLoading(true)
  }
  const snackbar = useSnackbar()

  const onSuccess = (msg: any) => {
    setLoading(false)
    snackbar.trigger({
      message: msg,
      severity: 'success',
    })
    setTimeout(() => {
      navigate('/homepage')
    }, 1500)
    console.log(msg)
  }

  const onError = (error: any) => {
    setLoading(false)
    snackbar.trigger({
      message: 'Your login details appear to be incorrect',
      severity: 'error',
    })
  }

  const togglePassword = () => {
    setPasswordShown(!passwordShown)
  }
  return (
    <LoginWrapper>
      <div className="welcome">
        <h1>Welcome back👋🏽</h1>
        <p>Enter your log in details to continue</p>
      </div>
      <FormWrapper>
        <div className="each-form">
          <label>Email address</label>
          <InputLogin
            type="email"
            name="email"
            value={email}
            onChange={handleChange}
          />
        </div>
        <div className="each-form">
          <label>Password</label>
          <PasswordContainer>
            <InputLogin
              type={passwordShown ? 'text' : 'password'}
              name="password"
              value={password}
              onChange={handleChange}
            />
            <div onClick={togglePassword} className="img">
              {passwordShown ? <FiEye /> : <FiEyeOff />}
            </div>
          </PasswordContainer>
        </div>
        <div className="each-form revert">
          <Link to="/accounts/forgot-password" className="option-link">
            <p className="to-left">Forgot password</p>
          </Link>
          <VerificationButton onClick={LoginAccount}>
            Log In {loading && <Spinner />}
          </VerificationButton>
          <Link to="/accounts/register" className="option-link">
            <p className="to-center">
              <span>Don't have an account?</span> Sign up
            </p>
          </Link>
        </div>
      </FormWrapper>
    </LoginWrapper>
  )
}

export { LoginForm }
